import React from 'react';
import { Chip } from '@mui/material';
import type { ChipStyle, E2IConfig, RegisterCode } from '../../types/e2i';
import { REGISTER_COLORS } from '../../types/e2i';
import { registerLabel } from '../../utils/e2i';

/** A document status (from one of the status maps in types/e2i). */
export const StatusChip: React.FC<{ status?: ChipStyle; fallback?: string }> = ({ status, fallback }) => (
  <Chip
    size="small"
    color={status?.color || 'default'}
    variant={status?.outlined ? 'outlined' : 'filled'}
    label={status?.label || fallback || '—'}
  />
);

/** The register status ("10 · Enquiry open"), coloured per code. */
export const RegisterChip: React.FC<{ code: RegisterCode | null | undefined; name?: string | null; config?: E2IConfig | null }> = ({ code, name, config }) => {
  if (!code) return <Chip size="small" variant="outlined" label="No register status" />;
  const colors = REGISTER_COLORS[code] || { bg: '#eceff1', fg: '#37474f' };
  return <Chip size="small" label={registerLabel(code, name, config)} sx={{ bgcolor: colors.bg, color: colors.fg, fontWeight: 600 }} />;
};
